<template>
<!--消息管理-->
  <div id="messageManager">
    <div class="allMenuHead">
      <div v-if="$childMenu.indexOf('消息推送') >= 0" :class="step === 1 ? 'active' : ''" @click="toUrl('messagePushing', 1)" class="d_i headTab p_r">消息推送<div class="p_a"></div></div>
      <div v-if="$childMenu.indexOf('会议推送') >= 0" :class="step === 2 ? 'active' : ''" @click="toUrl('meetingPushing', 2)" class="d_i headTab p_r">会议推送<div class="p_a"></div></div>
      <div v-if="$childMenu.indexOf('消息日志') >= 0" :class="step === 3 ? 'active' : ''" @click="toUrl('messageLog', 3)" class="d_i headTab p_r">消息日志<div class="p_a"></div></div>
    </div>
    <div class="allHeaderRouter">
      <transition name="fadeLeft">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
let Time
let reflashTime
export default {
  name: 'messageManager',
  data () {
    return {
      step: 1,
      ContentReleaseNumber: '',
      UnReviewCount: '',
      size: 1,
      showMenu: true,
      appowner: JSON.parse(window.sessionStorage.getItem('nowApp')),
      isAdmin: window.localStorage.getItem('isAdmin')
    }
  },
  created () {
    if (window.screen.width < 1400) {
      this.size = 0.92
    }
    console.log('11111', this.$childMenu)
    // this.getApprovalPendingCount()
    // this.getUnReviewCount()
    Time = setInterval(p => {
      if (window.location.href.indexOf('messagePushing') >= 0) {
        this.step = 1
      } else if (window.location.href.indexOf('meetingPushing') >= 0) {
        this.step = 2
      } else if (window.location.href.indexOf('messageLog') >= 0) {
        this.step = 3
      }
    }, 100)
    reflashTime = setInterval(p => {
      let data = window.sessionStorage.getItem('reflash')
      if (data === 'need') {
        window.sessionStorage.setItem('reflash', '')
        // this.getApprovalPendingCount()
        // this.getUnReviewCount()
      }
    }, 100)
  },
  destroyed () {
    clearInterval(Time)
    clearInterval(reflashTime)
  },
  methods: {
    toUrl (url, num) {
      this.step = num
      this.$router.push(url)
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/messageManager/messageManager.vue